import { estabelecimento } from "../Estabelecimento/estabelecimento"

export function buscaPedidoSenha(id, senha, callback) {
  axios.get('Pedido/GetPedidoSenha', {
      params: {
          urlEmpresa: estabelecimento.urlEmpresa,
          id,
          senha
      }
  }).then(({ data }) => {
      callback(data.pedidoDel)
  }).catch(error => console.log(error))
}